import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { StickyCta } from './components/StickyCta';
import { testimoniosTanda1, testimoniosTanda2 } from './data/testimonios';
export function App() {
  return <div className="min-h-screen w-full bg-ivory font-sans text-ink selection:bg-gold selection:text-ink" data-id="element-0" data-mp="3iiwdijzxza14">
      <MetaPixel data-id="element-1" data-mp="3mkhofzsx1e8o" />
      <main data-id="element-2" data-mp="3mjzpgvevclx2">
        <Hero data-id="element-3" data-mp="3mjg8bgx1m1k3" />
        <SocialProofBar data-id="element-4" data-mp="3rc9f0ac2njyt" />
        <Testimonials testimonials={testimoniosTanda1} background="ivory" data-id="element-5" data-mp="3rbrcivytg9ig" />
        <PainGrid data-id="element-6" data-mp="5yi8qe3h5da" />
        <BigIdea data-id="element-7" data-mp="6hq1ea16ddl" />
        <ProductReveal data-id="element-8" data-mp="4wwnrzgd0hb" />
        <Tomes data-id="element-9" data-mp="56mnfkhz7n0" />
        <Bonuses data-id="element-10" data-mp="7su7f7e1n58" />
        <Urgency data-id="element-11" data-mp="2zld1d7i6tbah" />
        <Pricing data-id="element-12" data-mp="2zlv6ktmtuzuj" />
        <Transformation data-id="element-13" data-mp="2zmepodo7rua5" />
        <Testimonials testimonials={testimoniosTanda2} title="Más organizadoras, más fiestas dirigidas de verdad" background="ivory" data-id="element-14" data-mp="2zmwh8wzxlkbq" />
        <Guarantee data-id="element-15" data-mp="38l03xwmnkn54" />
        <Faq data-id="element-16" data-mp="38kgk2adfzoog" />
        <CostOfInaction data-id="element-17" data-mp="38num1hi71vvd" />
        <Close data-id="element-18" data-mp="3dkl60fx4dbm2" />
      </main>
      <Footer data-id="element-19" data-mp="3dlw4q1bpjt6b" />
      <StickyCta data-id="element-20" data-mp="3dmfqjt4hb1pm" />
    </div>;
}